// stores/columnStore.ts
import { defineStore } from "pinia"

export const useColumnStore = defineStore("columnStore", {
  state: () => ({
    columnConfigs: {} as Record<string, any[]>
  }),

  persist: true,   // 🔥 THIS is all you need with your plugin

  actions: {
    setColumns(endpoint: string, columns: any[]) {
      this.columnConfigs[endpoint] = columns
    },

    getColumns(endpoint: string) {
      return this.columnConfigs[endpoint]
    }
  }
})
